import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cn } from "@volca/ui/lib/utils";

const GAP = {
  0: "gap-0",
  0.5: "gap-0.5",
  1: "gap-1",
  1.5: "gap-1.5",
  2: "gap-2",
  2.5: "gap-2.5",
  3: "gap-3",
  4: "gap-4",
  5: "gap-5",
  6: "gap-6",
  8: "gap-8",
  10: "gap-10",
  12: "gap-12",
} as const;

const ALIGN = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  baseline: "items-baseline",
  stretch: "items-stretch",
} as const;

const JUSTIFY = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly",
} as const;

export type StackGap = keyof typeof GAP;

export interface StackProps extends useRender.ComponentProps<"div"> {
  direction?: "column" | "row";
  gap?: StackGap;
  align?: keyof typeof ALIGN;
  justify?: keyof typeof JUSTIFY;
  wrap?: boolean;
  inline?: boolean;
}

export const Stack = ({
  direction = "column",
  gap = 0,
  align,
  justify,
  wrap = false,
  inline = false,
  className,
  render,
  ref,
  ...props
}: StackProps) =>
  useRender({
    defaultTagName: "div",
    render,
    ref,
    props: mergeProps<"div">(
      {
        className: cn(
          inline ? "inline-flex" : "flex",
          direction === "row" ? "flex-row" : "flex-col",
          GAP[gap],
          align && ALIGN[align],
          justify && JUSTIFY[justify],
          { "flex-wrap": wrap },
          className,
        ),
      },
      props,
    ),
  });
